module.exports = __webpack_public_path__ + "img/68.48f63189.jpg";